var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"industry-distribution"},[_c('div',{ref:"industryChart",staticClass:"chart-container"}),_c('DashboardLoading',{attrs:{"visible":_vm.initLoading && _vm.loading,"text":"加载部署行业分布数据","size":"normal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }